export const iconFontAwesomeHumanitarianTent = (
	<i className="fa-solid fa-tent"></i>
);
